import { render, staticRenderFns } from "./ManifestStatusBadge.vue?vue&type=template&id=759df826&"
import script from "./ManifestStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ManifestStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports